import { track, EventTypes } from '@mc/track-event'

// Hero section
export const HERO_LOCATION = 'hero'

export const trackTrailerActionClicked = ({ slug }: { slug: string }) =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'Trailer',
    class: slug,
    category: 'class-navigation',
    location: HERO_LOCATION,
    page_path: window.location.pathname,
    page_category: 'class',
  })

// Skills You’ll Learn section
export const SKILLS_YOU_LEARN_LOCATION = 'Skills You’ll Learn'

export const trackSkillsYoullLearnViewed = (props?: {
  location?: number
  cardTitle?: string
}) =>
  track(`${SKILLS_YOU_LEARN_LOCATION} Viewed`, {
    location: props?.location,
    cardTitle: props?.cardTitle,
  })

export const trackViewLessonPlanClicked = () =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'View Lesson Plan',
    location: SKILLS_YOU_LEARN_LOCATION,
  })

export const trackLessonPopoverClosed = () =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'close',
    location: 'View lesson plan popover',
  })

// Trailer and Sample section
const TRAILER_SAMPLE_LOCATION = 'Trailer and Sample'

export const trackTrailerSectionViewed = () =>
  track(`${TRAILER_SAMPLE_LOCATION} Viewed`)

export const trackTrailerSampleToggled = (type: 'Trailer' | 'Sample') =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: type,
    location: TRAILER_SAMPLE_LOCATION,
  })

// From here, go anywhere section
export const COURSES_CAROUSEL_LOCATION = 'From here, go anywhere'

export const trackCoursesCarouselSectionViewed = () =>
  track(`${COURSES_CAROUSEL_LOCATION} Viewed`)

export const trackCoursesCarouselTileClicked = () =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'click',
    location: COURSES_CAROUSEL_LOCATION,
  })

// One membership. Infinite possibilities section
export const ONE_MEMBERSHIP_LOCATION = 'One membership. Infinite possibilities'

export const trackOneMembershipViewed = () =>
  track(`${ONE_MEMBERSHIP_LOCATION} Viewed`)

// Start your journey today section
export const START_YOUR_JOURNEY_TODAY_LOCATION = 'Start your journey today'

export const trackStartYourJourneyTodayViewed = () =>
  track(`${START_YOUR_JOURNEY_TODAY_LOCATION} Viewed`)

// Member Stories section
export const MEMBER_STORIES_LOCATION = 'Member Stories'

export const trackMemberStoriesViewed = () =>
  track(`${MEMBER_STORIES_LOCATION} Viewed`)

export const trackMemberStoriesArrowClick = (arrow: 'left' | 'right') =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: arrow,
    location: MEMBER_STORIES_LOCATION,
  })
